import React, { Component } from 'react';
import Settings from './Quickbar/Settings';

class Quickbar extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false };
    }

    render() {
        const { open } = this.state;
        return (
            <div style={{position:'fixed', bottom:'20px', right:'20px', zIndex:9999}}>
                {open && (
                    <div style={{
                        background:'#fff',
                        borderRadius:'10px',
                        boxShadow:'0 4px 20px rgba(0,0,0,0.2)',
                        padding:'20px',
                        marginBottom:'10px',
                        width:'260px'
                    }}>
                        <Settings />
                    </div>
                )}
                <button
                    onClick={() => this.setState({ open: !open })}
                    style={{
                        width:'45px',
                        height:'45px',
                        borderRadius:'50%',
                        background:'#191F38',
                        border:'none',
                        color:'#fff',
                        fontSize:'20px',
                        cursor:'pointer',
                        display:'flex',
                        alignItems:'center',
                        justifyContent:'center',
                        boxShadow:'0 4px 10px rgba(0,0,0,0.3)',
                        marginLeft:'auto'
                    }}
                >
                    <i className="flaticon-gear" />
                </button>
            </div>
        );
    }
}

export default Quickbar;
